import React, { useState } from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import FeedbackModal from './FeedbackModal';

interface Props {
  featureName: string;
  url?: string;
  size?: 'mini' | 'tiny' | 'small' | 'large' | 'big' | 'huge' | 'massive';
  color?: React.ComponentProps<typeof Icon>['color'];
  style?: React.CSSProperties;
  trigger?: React.ReactElement;
}

const FeedbackButton: React.FC<Props> = ({
  featureName,
  url,
  size = 'small',
  color = 'orange',
  style,
  trigger,
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const defaultTrigger = (
    <Icon
      name="comment outline"
      size={size}
      color={color}
      style={{
        cursor: 'pointer',
        ...style,
      }}
      onClick={handleButtonClick}
    />
  );

  const triggerElement = trigger
    ? React.cloneElement(trigger, { onClick: handleButtonClick })
    : defaultTrigger;

  return (
    <>
      <Popup
        content={t('FeedbackButtonTooltip')}
        trigger={triggerElement}
        position="top center"
        size="mini"
      />
      {isModalOpen && (
        <FeedbackModal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          featureName={featureName}
          url={url}
        />
      )}
    </>
  );
};

export default FeedbackButton;
